import React from 'react';
import { BaseResourceListProps, SimpleList, SvgBin, SvgEdit } from '@app/components';
import { orderCancelReasonApi } from '@app/store';
import { IOrderCancelReason } from '@app/common';
import { theme } from '@app/theme';
import { createColumnHelper } from '@tanstack/react-table';
import { useTable } from '@app/hooks/useTable';
import { CheckPermissions } from '@app/components/CheckPermissions';

const columnHelper = createColumnHelper<IOrderCancelReason>();

export const OrderCancelReasonList = ({ onUpdate, onDelete, onRowPress, selectedRowItem }: BaseResourceListProps<IOrderCancelReason>) => {
  const columns = [
    columnHelper.accessor("reason", {
      header: () => (
        <SimpleList.HeaderItem width="75%">
          <SimpleList.HeaderItemLabel>Raison</SimpleList.HeaderItemLabel>
        </SimpleList.HeaderItem>
      ),
      cell: (info) => (
        <SimpleList.ItemCol width="75%">
          <SimpleList.ItemText align="left" bold numberOfLines={2} active={info.active}>
            {info.getValue()}
          </SimpleList.ItemText>
        </SimpleList.ItemCol>
      ),
    }),
    columnHelper.display({
      id: 'actions',
      header: () => (
        <SimpleList.HeaderItem width="25%" align='center'>
          <SimpleList.HeaderItemLabel>Actions</SimpleList.HeaderItemLabel>
        </SimpleList.HeaderItem>
      ),
      cell: ({ row, active }) => (
        <SimpleList.ItemCol width="25%">
          <SimpleList.ItemActions>
            <CheckPermissions permissions={['dashboard::order-cancel-reasons.update']}>
              <SimpleList.ItemAction onPress={() => onUpdate(row.original)}>
                <SvgEdit color={active ? '#FFF' : theme.colors.celadonblue} />
              </SimpleList.ItemAction>
            </CheckPermissions>

            <CheckPermissions permissions={['dashboard::order-cancel-reasons.delete']}>
              <SimpleList.ItemAction onPress={() => onDelete(row.original)}>
                <SvgBin color={active ? '#FFF' : theme.colors.celadonblue} />
              </SimpleList.ItemAction>
            </CheckPermissions>
          </SimpleList.ItemActions>
        </SimpleList.ItemCol >
      ),
    }),
  ];

  const { table, setSearch, isFetching } = useTable({
    columns,
    useQuery: ({ pagination, search }) => orderCancelReasonApi.useReadManyOrderCancelReasonsQuery({
      pagination,
      filters: {
        reason: {
          $contains: search
        }
      },
      sort: ['reason:ASC']
    })
  });

  return <SimpleList
    table={table}
    isFetching={isFetching}
    onSearch={setSearch}
    selectedRowItem={selectedRowItem}
    onRowPress={onRowPress} />;
};
